import moment from 'moment'
import { useMemo } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { getFullUrl } from '../../../helpers/files'
import downloadIcon from '../../../imgs/download.png'
import flammableIcon from '../../../imgs/flammable.png'
import printIcon from '../../../imgs/printer.png'
import { PackageActionsMenu } from './PackageActionsMenu'
import { RefundPackageModal } from './RefundPackageModal'
import { UpdatePackageModal } from './UpdatePackageModal'
import { UploadFileOfficeModal } from './UploadFileOfficeModal'

const getLinkUrlForItem = async item => {
  const url = getFullUrl(item.buyingReciptKey)
  window.open(url, '_blank')
}
const copyToClipboard = str => {
  navigator.clipboard.writeText(str)
}

export const useUserColDefs = ({
  updatePackageMutation,
  forceUpdateFunction,
  setItemToUnite,
  setItemToReturn,
  handleReq,
  handleCancelReq,
  onDeletePackage,
  userPermissions,
  includeActions,
  getStatus,
  pkgReqs,
}) =>
  useMemo(() => {
    const canManagePackageReq = userPermissions?.['Admin'] || userPermissions?.['SeniorAgent'] || userPermissions?.['Agent']

    const canDeletePackage =
      userPermissions?.['Admin'] || userPermissions?.['SeniorAgent'] || userPermissions?.['Agent'] || userPermissions?.['OfficeManager']
    return [
      {
        field: 'trackingNumberToIsrael',
        headerName: 'XLT',
        cellRenderer: params => (
          <OverlayTrigger
            placement='bottom'
            overlay={
              <Tooltip>
                <span>Click to copy</span>
              </Tooltip>
            }
          >
            <span style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(params.value)}>
              {params.value}
            </span>
          </OverlayTrigger>
        ),
        minWidth: 120,
      },
      {
        field: 'brand',
        headerName: 'Brand',
        minWidth: 100,
      },
      {
        field: 'status',
        headerName: 'Status',
        valueGetter: params => {
          return getStatus(params.data)
        },
        minWidth: 150,
      },
      {
        field: 'price',
        headerName: 'Price',
        minWidth: 100,
      },
      {
        field: 'valueInUSD',
        headerName: 'Value in USD',
        minWidth: 140,
      },
      {
        field: 'content',
        headerName: 'Content',
        cellRenderer: params => {
          const totalItems = params.data.contents?.reduce((t, v) => t + parseInt(v.quantity), 0) || '-'
          const tooltipContent = params.data?.contents?.map((c, i) => {
            return (
              <span key={i}>
                {i > 0 && ', '}
                {c.productCategory} X {c.quantity}
              </span>
            )
          })

          return (
            <OverlayTrigger placement='top' overlay={<Tooltip>{tooltipContent}</Tooltip>}>
              <div>{totalItems}</div>
            </OverlayTrigger>
          )
        },
        minWidth: 100,
      },
      {
        field: 'createdAt',
        headerName: 'Created At',
        cellRenderer: params => {
          return params.value ? moment(params.value).format('L HH:mm') : ''
        },
        minWidth: 160,
      },
      {
        field: 'paymentTransactionNumber',
        headerName: 'Asmachta',
        minWidth: 120,
      },
      {
        field: 'datePayed',
        headerName: 'Paid Date',
        cellRenderer: params => {
          return params.value ? moment(params.value).format('DD/MM/YYYY') : ''
        },
        minWidth: 120,
      },
      {
        field: 'batchName',
        headerName: 'Batch Name',
        width: 120,
      },
      {
        field: 'warehouse',
        headerName: 'Warehouse',
        width: 100,
      },
      {
        field: 'warehouseLocation',
        headerName: 'Location',
        valueGetter: params => {
          return params.data.warehouseLocation?.join(', ') || ''
        },
        width: 100,
      },
      {
        field: 'isFlammable',
        headerName: 'Flammable',
        cellRenderer: params => {
          return params.value ? <img src={flammableIcon} height='30px' alt='flammable' /> : ''
        },
        width: 100,
      },
      {
        field: 'insurance',
        headerName: 'Insurance',
        width: 100,
      },
      ...(includeActions
        ? [
            {
              field: 'actions',
              headerName: 'Actions',
              minWidth: 300,
              sortable: false,
              filter: false,
              cellRenderer: params => {
                const p = params.data
                return (
                  <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                    {!p.isDraft && <UpdatePackageModal item={p} updatePackage={updatePackageMutation} pkgReqs={pkgReqs} />}
                    <RefundPackageModal
                      itemId={p.id}
                      forceUpdate={forceUpdateFunction}
                      transactionId={p.paymentTransactionId}
                      transactionToken={p.paymentTransactionToken}
                      maxRefund={p.shippingPaid}
                      hasRefunded={p.hasRefunded}
                    />
                    <div
                      style={{
                        border: '1px dashed grey',
                        width: 'fit-content',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {!p.isDraft && <UploadFileOfficeModal itemId={p.id} useForceUpdate={forceUpdateFunction} />}
                        {p.buyingReciptKey && (
                          <img
                            src={downloadIcon}
                            height='30px'
                            onClick={() => getLinkUrlForItem(p)}
                            style={{ marginLeft: '5px', cursor: 'pointer' }}
                            alt='download'
                          />
                        )}
                      </div>
                    </div>

                    <Link
                      to={`/office-sticker/${p.trackingNumberToIsrael}/${p.costumer_firstName + ' ' + p.costumer_LastName}/${p.unit}/${p.brand}/${
                        p.shippingAdress_adress +
                        ' ' +
                        p.shippingAdress_apartmentNumber +
                        ' ' +
                        p.shippingAdress_city +
                        ' ' +
                        p.shippingAdress_postalCode
                      }`}
                      target='_blank'
                    >
                      <img src={printIcon} height='30px' alt='print' />
                    </Link>

                    {(canManagePackageReq || canDeletePackage) && (
                      <PackageActionsMenu
                        pkg={p}
                        pkgReqs={pkgReqs.filter(req => req.packageId === p.id || req.unitedPackageId === p.id)}
                        handleReq={handleReq}
                        handleCancelReq={handleCancelReq}
                        setItemToUnite={setItemToUnite}
                        setItemToReturn={setItemToReturn}
                        onDeletePackage={onDeletePackage}
                        canDeletePackage={canDeletePackage}
                      />
                    )}
                  </div>
                )
              },
            },
          ]
        : []),
    ]
  }, [
    userPermissions,
    includeActions,
    getStatus,
    updatePackageMutation,
    forceUpdateFunction,
    pkgReqs,
    handleReq,
    handleCancelReq,
    setItemToUnite,
    setItemToReturn,
    onDeletePackage,
  ])
